import createAsyncSlice from './helper/createAsyncSlice';
import { API_URL } from '../config/App';

let photos = createAsyncSlice({
  name: 'photos',
  initialState: {
    list: [],
    user: 0,
    pages: 1,
    infinite: true,
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    clearPhotos(state, action) {
      state.list = [];
    },
    addPage(state) {
      state.pages++;
    },    
    addPhotos(state, action) {
      state.list.push(...action.payload.data);
      //state.pages++;
      if (action.payload.meta.current_page === action.payload.meta.last_page) state.infinite = false;
    },
    removePhotos(state) {
      state.pages = 1;
      state.infinite = true;
      state.list = [];
      state.data = null;
      state.error = null;
      state.loading = false;
    },
    searchbyTitle(state, action) {

      state.list.push(...action.payload.payload.data);

      //const data = action.payload.payload.data;
      //const overFiveKg = data?.filter(({ title }) => title.toUpperCase().indexOf(action.payload.chave.toUpperCase()) > -1);
      //const transformPound = overFiveKg?.map((photo) => ({
      //  ...photo,
      //  peso: Math.floor(photo.peso * 5.2),
      //}));

      //state.list.push(...transformPound);
      state.infinite = false;
    },
  },
  fetchConfig: (data) => ({
    url: `${API_URL}/club/getall?page=${data.page}&total=20&key=${data.key}&category=${data.category}&user=${data.user}&shared=${data.shared}&area_id=${data.area}`,
    options: {
      method: 'GET',
      cache: 'no-store',
    },
  }),
});

const slice = createAsyncSlice({
  name: 'photos',
  initialState: {
    cache: 5000,
    list: [],
    user: 0,
    pages: 0,
    infinite: true,
  },
  fetchConfig: () => ({
    url:
    `${API_URL}/club/getall?page=1&total=6&user=0`,
    options: {
      method: 'GET',
      cache: 'no-store',
    },
  }),
});


export const {  addPhotos,  addPage, addPhotos2, searchbyTitle, setUser, clearPhotos, removePhotos } = photos.actions;
export const fetchPhotos = photos.asyncAction;
export const fetchPhotos2 = slice.asyncAction;

export const getOverFiveKg = (state) => {
  const data = state;
  const overFiveKg = data?.filter(({ peso }) => peso >= 0);
  const transformPound = overFiveKg?.map((photo) => ({
    ...photo,
    peso: Math.floor(photo.peso * 2.2),
  }));
  return transformPound;
};

export const getbyTitle = (state, chave) => {
  console.log(chave);
  const data = state;

  const overFiveKg = data?.filter(({ title }) => title.indexOf(chave) > -1);
  const transformPound = overFiveKg?.map((photo) => ({
    ...photo,
    peso: Math.floor(photo.peso * 5.2),
  }));
  return transformPound;
};

export const loadNewPhotose = (page = 1, user = 0, category = '', key = '', shared = 1) => async (dispatch) => {
  const { payload } = await dispatch(fetchPhotos({page, user, key, shared}));
  dispatch(addPhotos(payload));
};

export const loadNewPhotos = (area = 1, page = 1, category = '', user = 0, key = '', shared = 1) => async (
  dispatch,
  getState,
) => {
  console.log (area);
  const { photos } = getState();
  dispatch(addPage());
  const { payload } = await dispatch(
    fetchPhotos({ page: photos.pages, user, key, shared, area }),
  );
  dispatch(addPhotos(payload));
};

export const loadSnippets = (area = 3, page = 1, category = 9, user = 0, key = '', shared = 1) => async (
  dispatch,
  getState,
) => {
  console.log('ENTROU NO SNIPPETS');
  const { photos } = getState();
  dispatch(addPage());
  const { payload } = await dispatch(
    fetchPhotos({ page: photos.pages, category, user, key, shared, area }),
  );
  //dispatch();
  dispatch(addPhotos(payload));
};

export const loadNewPhotosInt = (page = 1, category = '', user = 1, key = '', shared = 1) => async (dispatch) => {
  console.log('user',user);
  const { payload } = await dispatch(fetchPhotos({page:page, category: category, user:user, key:key, shared:shared}));
  dispatch(addPhotos(payload));
};

export const searchTitle = (chave = '', category = '', user = 0, shared = 1) => async (dispatch) => {
  const { payload } = await dispatch(fetchPhotos({category:category, user:user, key:chave, shared:shared}));
  dispatch(removePhotos());
  dispatch(searchbyTitle({payload, chave}));
};

export const loadNewPhotosInicial2 = (page = 1, category = '', user = 0, key = '', shared = 1) => async (dispatch) => {
  const { payload } = await dispatch(fetchPhotos({page, category, user, key, shared}));
  dispatch(removePhotos());
  dispatch(addPhotos(payload));
};

export const loadNewPhotosInicial = (page = 1, category = '', user = 0, key = '', shared = 1) => async (
  dispatch,
  getState,
) => {
  const { photos } = getState();
  dispatch(addPage());
  const { payload } = await dispatch(
    fetchPhotos({ page: photos.pages, category, user, key, shared }),
  );
  dispatch(removePhotos());
  dispatch(addPhotos(payload));
};

export const loadNewPhotosInicialInt = (page = 1, category = '', user = 234, key = '', shared = 1) => async (dispatch) => {
  console.log('user',user);
  const { payload } = await dispatch(fetchPhotos({page:page, category:category, user:user, key:key, shared:shared}));
  dispatch(removePhotos());
  dispatch(addPhotos(payload));
};

export default photos.reducer;
